module.exports = __webpack_public_path__ + "img/sign-54.5ca24d00.jpg";